import { useNotification } from '@/hooks';
import {
  useCreateAssignmentMutation,
  useUpdateAssignmentMutation,
} from '../service';
import { useUpdateAssetMutation } from '@/pages/Inventory/pages/Assets/service';
import { CreateAssignmentsSchema } from '../models';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { useNavigate } from 'react-router-dom';

const useAssignmentsActions = () => {
  const navigate = useNavigate();
  const [createAssignment, { isLoading: isCreatingAssignment }] =
    useCreateAssignmentMutation();
  const [updateAssignment, { isLoading: isUpdatingAssignment }] =
    useUpdateAssignmentMutation();
  const [updateAsset] = useUpdateAssetMutation();

  const { showNotification } = useNotification();

  const onCreateAssignment = async (
    data: CreateAssignmentsSchema,
    reset: () => void
  ) => {
    try {
      await createAssignment(data).unwrap();
      showNotification(
        'Asignación creada correctamente',
        NotificationSeverity.success
      );
      reset();
      navigate('/inventory/assignments');
    } catch (error: any) {
      showNotification(
        'Ocurrió un error al crear la asignación. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
    }
  };

  const onUpdateAssignment = async (
    assignmentId: string,
    data: Partial<CreateAssignmentsSchema>,
    onSuccess?: () => void
  ) => {
    try {
      await updateAssignment({ assignmentId, body: data }).unwrap();
      if (data.assetId && data.userId) {
        await updateAsset({
          assetId: data.assetId,
          body: { userId: data.userId },
        }).unwrap();
      }
      showNotification(
        'Asignación actualizada correctamente',
        NotificationSeverity.success
      );
      if (onSuccess) onSuccess();
    } catch (error: any) {
      showNotification(
        'Ocurrió un error al actualizar la asignación. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
    }
  };

  const onDeleteAssignment = async (
    assignmentId: string,
    onSuccess?: () => void
  ) => {
    try {
      await updateAssignment({
        assignmentId,
        body: { status: 'disabled' },
      }).unwrap();
      showNotification(
        'Asignación eliminada correctamente',
        NotificationSeverity.success
      );
      if (onSuccess) onSuccess();
    } catch (error: any) {
      showNotification(
        'Ocurrió un error al eliminar la asignación. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
    }
  };

  return {
    isCreatingAssignment,
    isUpdatingAssignment,
    onCreateAssignment,
    onUpdateAssignment,
    onDeleteAssignment,
  };
};

export default useAssignmentsActions;
